export interface SpriteOptions {
	spriteElement: HTMLElement | null;
	spriteFrames: number;
	animationSpeedInterval?: number;
}

export class SpritePlayer {
	private animationInterval: any;
	private animationIntervalSpeed: number; // milliseconds;
	private spriteElement: HTMLElement;
	private spriteFrames: number;
	private widthOfSpriteSheet: number;
	private widthOfEachSprite: number;
	private firstTime = true;

	public constructor(options: SpriteOptions) {
		this.spriteElement = options.spriteElement as HTMLElement;
		this.spriteFrames = options.spriteFrames;
		this.animationIntervalSpeed = options.animationSpeedInterval ?? 24;
		this.widthOfSpriteSheet = window.innerWidth * this.spriteFrames;
		this.widthOfEachSprite = window.innerWidth;
		this.spriteElement.style.backgroundSize = `${this.widthOfSpriteSheet}px 100%`;
	}

	public stop(): void {
		clearInterval(this.animationInterval);
	}

	public hide(): void {
		setTimeout(() => {
			this.stop(); // This just makes sure that the interval is stopped
			this.spriteElement.style.display = 'none';
		}, this.animationIntervalSpeed);
	}

	public play(loop: boolean = false): void {
		if (this.spriteElement) {
			let position = this.widthOfEachSprite;
			const diff = this.widthOfEachSprite; // difference between two sprites
			this.showElement();
			this.animationInterval = setInterval(() => {
				this.spriteElement!.style.backgroundPosition = `-${position}px 0px`;
				if (position < this.widthOfSpriteSheet) {
					position = position + diff;
				} else {
					if (loop) {
						position = this.widthOfEachSprite;
					} else {
						this.stop();
					}
				}
			}, this.animationIntervalSpeed);
		}
	}

	public reverse(updatedAnimationIntervalSpeed: number = this.animationIntervalSpeed): void {
		if (this.spriteElement) {
			let position = this.widthOfSpriteSheet;
			const diff = this.widthOfEachSprite; // difference between two sprites
			this.showElement();
			this.animationInterval = setInterval(() => {
				this.spriteElement!.style.backgroundPosition = `-${position}px 0px`;
				if (position >= this.widthOfEachSprite) {
					position = position - diff;
				} else {
					this.stop();
				}
			}, updatedAnimationIntervalSpeed);
		}
	}

	private showElement(): void {
		if (this.firstTime) {
			this.firstTime = false;
			this.spriteElement.style.display = 'block';
		} else {
			setTimeout(() => {
				this.spriteElement.style.display = 'block';
			}, this.animationIntervalSpeed);
		}
	}
}
